angular.module('settings', ['ui.router', 'ngResource', 'angularFileUpload'])
    .factory('ModuleSettings', function ($resource) {
        return $resource('/crm/api/settings/:module', {module: '@module'}, {
            list: {method: 'GET', isArray: false},
        })
    })
